function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#4E4E4E",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.877 19.59V6.497l.008-.182A2.941 2.941 0 018.818 3.59h6.202V1.96a.98.98 0 00-.98-.98H1.96a.98.98 0 00-.98.98v16.65c0 .541.44.98.98.98h3.917z",
  strokeWidth: 1.961
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.286 6.695c-.721 0-1.306.584-1.306 1.305v21.714c0 .721.585 1.306 1.306 1.306H28.57c.721 0 1.306-.585 1.306-1.306V12.993c0-.354-.144-.693-.399-.939L24.31 7.061a1.305 1.305 0 00-.907-.366H10.286z",
  strokeWidth: 1.961
}), /*#__PURE__*/React.createElement("rect", {
  strokeWidth: 1.143,
  x: 13.143,
  y: 15.429,
  width: 12.571,
  height: 1.143,
  rx: 0.571
}), /*#__PURE__*/React.createElement("rect", {
  strokeWidth: 1.143,
  x: 13.143,
  y: 18.857,
  width: 12.571,
  height: 1.143,
  rx: 0.571
}), /*#__PURE__*/React.createElement("rect", {
  strokeWidth: 1.143,
  x: 13.143,
  y: 22.286,
  width: 12.571,
  height: 1.143,
  rx: 0.571
}), /*#__PURE__*/React.createElement("rect", {
  strokeWidth: 1.143,
  x: 13.143,
  y: 25.714,
  width: 12.571,
  height: 1.143,
  rx: 0.571
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.857 5.714v4.572a2.286 2.286 0 002.286 2.285h4.571",
  strokeWidth: 2.286
}));

function SvgDaxCopyicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxCopyicon);
export default __webpack_public_path__ + "static/media/dax-copyicon.7b104353.svg";
export { ForwardRef as ReactComponent };